module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "donate"
  }, [_c('carousel', {
    staticClass: "carousel"
  }), _vm._v(" "), _c('donate-panel', {
    staticClass: "panel",
    attrs: {
      "remainingDuration": _vm.remainingDuration,
      "durationOfToday": _vm.durationOfToday
    }
  }), _vm._v(" "), _c('leaderboard', {
    staticClass: "leaderboard"
  }), _vm._v(" "), _c('touch', {
    staticClass: "gotolls",
    on: {
      "tap": _vm.gotoLiulishuo
    }
  }, [_vm._v("去学习")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/Mee/Work/lls-with-tfchina/~/vue-loader/lib/template-compiler?{"id":"data-v-0ae08b30","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/Users/Mee/Work/lls-with-tfchina/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Donate.vue
// module id = 196
// module chunks = 1